<script lang="ts">
  import type { Activity } from "./types";

  export let activities: Activity[] = [];
  export let showTitle: boolean = false;

  const formatTime = (isoString: string) => {
    try {
      const date = new Date(isoString);
      return date.toLocaleTimeString();
    } catch {
      return isoString;
    }
  };
</script>

<div
  class="bg-[#34344A] border border-white/10 rounded-xl p-4 sm:p-6"
>
  {#if showTitle}
    <h3
      class="text-[1.125rem] font-bold text-white mb-4 uppercase tracking-[0.5px]"
    >
      Recent Sync Activity
    </h3>
  {:else}
    <h3
      class="text-[1.125rem] font-bold text-white mb-4 uppercase tracking-[0.5px]"
    >
      Sync Activity
    </h3>
  {/if}
  <div
    class="max-h-[300px] overflow-y-auto thin-scrollbar"
    class:max-h-[500px]={showTitle}
  >
    {#if activities && activities.length > 0}
      {#each activities as activity}
        <div
          class="flex gap-4 py-3 px-4 mb-2 bg-black/20 border-l-[3px] rounded-md text-sm transition-all hover:bg-black/30 hover:translate-x-[2px]"
          class:border-l-green-500={activity.type === "success"}
          class:border-l-red-500={activity.type === "error"}
        >
          <span
            class="text-white/60 font-semibold font-['Courier_New',monospace] shrink-0 text-xs"
          >
            {formatTime(activity.timestamp)}
          </span>
          <span class="text-white/90 flex-1">{activity.message}</span>
        </div>
      {/each}
    {:else}
      <div class="text-center text-white/50 py-12">No recent activity</div>
    {/if}
  </div>
</div>
